import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core";
import Footer from "src/layout/CommonLayout/Footer";
import clsx from 'clsx';
import { useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import CssBaseline from '@material-ui/core/CssBaseline';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import SideBar from "src/layout/CommonLayout/SideBar";
import UserInfo from "src/layout/CommonLayout/UserInfo";
import SearchWeb from "src/layout/CommonLayout/SearchWeb";
import { AxiosGetJson, AxiosPostJson } from "src/Service/Config/AxiosMethod";
import Hidden from "@material-ui/core/Hidden";
import { Link } from "react-router-dom";
import PTTLogo from "src/images/logoPTT.png";
import {
  Sweetalert,
  AlertIcon,
  DialogConfirm,
} from "src/components/Systems/MaterialComponent";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Paper from "@material-ui/core/Paper";
import MenuList from "@material-ui/core/MenuList";
import MenuItem from "@material-ui/core/MenuItem";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Grid from '@material-ui/core/Grid';
import SearchIcon from '@material-ui/icons/Search';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import Grow from "@material-ui/core/Grow";
import { useMediaQuery } from '@material-ui/core';
import Popper from "@material-ui/core/Popper";
import { localJwtKey } from "src/Service/Config/ApiUrl";
import { useHistory } from "react-router";
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons';
import Notification from "./Notification";
import workPlace from "src/images/workplace2.png"
library.add(fab);
const drawerWidth = 270;

const useStyles = makeStyles((theme) => ({
  root: {
    // position:'relative',
    // zIndex:2,
    // marginBottom:'130px',
    color: "rgba(0, 0, 0, 0.65)",
    backgroundColor: "#ffffff",  //#f0f2f5
    display: "flex",
    fontFamily: `'Roboto', sans-serif`,

    "& h1, h2, h3, h4, h5, h6": {
      color: "rgba(0, 0, 0, 0.85)",
    },
  },

  content: {
    flexGrow: 1,
    // padding: theme.spacing(3),
    minHeight: "100vh",
    overflow: "hidden",
    // overflowX: "hidden",   //fee

  },

  toolbar: theme.mixins.toolbar,
  rootA: {
    display: 'flex',
  },
  appBar: {
    backgroundColor: '#ffffff',
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: drawerWidth,
  },
  title: {
    flexGrow: 1,
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    minHeight: '88px !important',
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    justifyContent: 'flex-start',
  },
  drawerHeaderMenu: {
    minHeight: '88px !important',
    // margin:'11px 0px',
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    justifyContent: 'flex-start',
  },
  contentA: {
    flexGrow: 1,
    overflow: "hidden",
    // padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginRight: -drawerWidth,
    // height:'100vh'
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: 0,
  },
  flex: {
    flex: 1,
  },
  list: {
    fontSize: "14px",
    margin: 0,
    paddingLeft: "0",
    listStyle: "none",
    paddingTop: "0",
    paddingBottom: "0",
    color: "inherit",
  },
  listItem: {
    float: "left",
    color: "inherit",
    position: "relative",
    display: "block",
    width: "auto",
    margin: "0px",
    padding: "5px",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      // "&:after": {
      //   width: "calc(100% - 30px)",
      //   content: '""',
      //   display: "block",
      //   height: "1px",
      //   marginLeft: "15px",
      //   backgroundColor: "#e5e5e5",
      // },
    },
  },
  listItemText: {
    padding: "0 !important",
  },
  IconBtn: {
    border: "1px solid #95caff",
    padding: "5px",
    width: '32px',
    height: '32px',
    marginRight: '2px'
  },
  dropdown: {
    borderRadius: "3px",
    border: "0",
    boxShadow: "0 2px 5px 0 rgba(0, 0, 0, 0.26)",
    top: "100%",
    zIndex: 1000,
    minWidth: "160px",
    padding: "5px 0",
    margin: "2px 0 0",
    fontSize: "14px",
    textAlign: "left",
    listStyle: "none",
    backgroundColor: "#fff",
    backgroundClip: "padding-box",
  },
  menuList: {
    padding: 0,
  },
  dropdownItem: {
    fontSize: "13px",
    padding: "10px 20px",
    margin: "0 5px",
    borderRadius: "2px",
    position: "relative",
    transition: "all 150ms linear",
    display: "block",
    clear: "both",
    fontWeight: 400,
    height: "fit-content",
    color: "#333",
    whiteSpace: "nowrap",
    minHeight: "unset",
  },
}));

function Layout(props) {
  const history = useHistory();
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [IsOpenAppbar, setIsOpenAppbar] = useState(false);
  const [lstMenu, setlstMenu] = useState([] as any);
  const [lstFacebook, setlstFacebook] = useState([] as any);
  const [lstYoutube, setlstYoutube] = useState([] as any);
  const [lstLine, setlstLine] = useState([] as any);
  const [lstWord, setlstWord] = useState([] as any);
  const [User, setUser] = useState([] as any);
  const [anchorElFace, setAnchorElFace] = useState(null as any);
  const [anchorElYoutube, setAnchorElYoutube] = useState(null as any);
  const [anchorElLine, setAnchorElLine] = useState(null as any);
  const [anchorElWordp, setAnchorElWordp] = useState(null as any);
  const matches = useMediaQuery('(min-width:400px)');

  useEffect(() => {
    GetMenu();
    GetContactTo();
  }, []);


  const localUserID = "vdsafdwxd31f";
  //#region click
  const handleClickFace = (event) => {
    if (anchorElFace && anchorElFace.contains(event.target)) {
      setAnchorElFace(null);
    } else {
      setAnchorElFace(event.currentTarget);
    }
  };

  const handleCloseAwayFace = (event) => {
    if (anchorElFace.contains(event.target)) {
      return;
    }
    setAnchorElFace(null);
  };

  const handleClickYoutube = (event) => {
    if (anchorElYoutube && anchorElYoutube.contains(event.target)) {
      setAnchorElYoutube(null);
    } else {
      setAnchorElYoutube(event.currentTarget);
    }
  };

  const handleCloseAwayYoutube = (event) => {
    if (anchorElYoutube.contains(event.target)) {
      return;
    }
    setAnchorElYoutube(null);
  };

  const handleClickLine = (event) => {
    if (anchorElLine && anchorElLine.contains(event.target)) {
      setAnchorElLine(null);
    } else {
      setAnchorElLine(event.currentTarget);
    }
  };

  const handleCloseAwayLine = (event) => {
    if (anchorElLine.contains(event.target)) {
      return;
    }
    setAnchorElLine(null);
  };

  const handleClickWordp = (event) => {
    if (anchorElWordp && anchorElWordp.contains(event.target)) {
      setAnchorElWordp(null);
    } else {
      setAnchorElWordp(event.currentTarget);
    }
  };

  const handleCloseAwayWordp = (event) => {
    if (anchorElWordp.contains(event.target)) {
      return;
    }
    setAnchorElWordp(null);
  };
  //#endregion  

  const handleLogOutClick = async (sEvent) => {
    let localUser = localStorage.getItem(localUserID);
    let dataSend = {
      nUserInfoID: localUser,
    };

    if (sEvent == "click") {
      DialogConfirm(
        async () => {
          await AxiosPostJson("Auth/Logout", dataSend);
          localStorage.removeItem(localJwtKey);
          localStorage.removeItem(localUserID);
          setUser([]);
          window.location.href = process.env.REACT_APP_URL + "Login";
        },
        false,
        "",
        "Do you want to log out ?"
      );
    } else {
      await AxiosPostJson("Auth/Logout", dataSend);
      localStorage.removeItem(localJwtKey);
      localStorage.removeItem(localUserID);
      setUser([]);

      Sweetalert.Warning(
        AlertIcon.warning,
        "Session timeout ! Please login again.",
        () => { history.push("/Login") }
      );
    }
  };
  const GetMenu = async () => {
    let result: any = await AxiosGetJson("Home/GetMenu", "");
    if (result) {
      let dataAll = [] as any;
      let subdata = [] as any;
      (result || []).forEach((eleBig) => {
        subdata = [];
        result.forEach((eleSmall) => {
          if (eleSmall.nMenuHeadID == eleBig.nMenuID) {
            subdata.push({
              value: eleSmall.nMenuID,
              label: eleSmall.sMenuName,
              sIcon: eleSmall.sIcon,
              Url: eleSmall.sUrl,
            });
          }
        });
        if (eleBig.nMenuHeadID == null) {
          dataAll.push({
            value: eleBig.nMenuID,
            label: eleBig.sMenuName,
            sIcon: eleBig.sIcon,
            Url: eleBig.sUrl,
            items: subdata,
          });
        }
      });
      setlstMenu(dataAll);
    }
  };
  const GetContactTo = async () => {
    var dataFacebook = { ID: "1" };
    let resultFacebook: any = await AxiosGetJson(
      "Home/GetContactTo",
      dataFacebook
    );
    if (resultFacebook) {
      setlstFacebook(resultFacebook);
    }
    var dataLine = { ID: "2" };
    let resultLine: any = await AxiosGetJson("Home/GetContactTo", dataLine);
    if (resultLine) {
      setlstLine(resultLine);
    }
    var dataYoutube = { ID: "3" };
    let resultYoutube: any = await AxiosGetJson(
      "Home/GetContactTo",
      dataYoutube
    );
    if (resultYoutube) {
      setlstYoutube(resultYoutube);
    }
    var dataWord = { ID: "4" };
    let resultWord: any = await AxiosGetJson("Home/GetContactTo", dataWord);
    if (resultWord) {
      setlstWord(resultWord);
    }
  };

  const brandComponent = (
    <div style={{ height: '86px' }}>
      <Link to="/">
        <img src={PTTLogo} alt="logo" width="120" height="53.48" style={{ position: 'absolute', top: '20%' }} />
      </Link>
    </div>
  );

  const RigthL = (
    <div>

      <List className={classes.list}>
        {/* Contact US */}
        <Hidden mdDown>
          <ListItem className={classes.listItem} style={{ marginTop: "20px" }}>
            {lstFacebook.length == 0 ? (
              <div></div>
            ) : lstFacebook.length == 1 ? (
              <a href={lstFacebook[0].sURL} target="_blank">
                <IconButton className={classes.IconBtn}>
                  <FontAwesomeIcon icon={['fab', 'facebook-square']} style={{ color: '#1773ea' }} />
                </IconButton>
              </a>
            ) : (
              <>
                <IconButton
                  onClick={handleClickFace}
                  className={classes.IconBtn}
                >
                  <FontAwesomeIcon icon={['fab', 'facebook-square']} style={{ color: '#1773ea' }} />
                </IconButton>
                <Popper
                  open={Boolean(anchorElFace)}
                  anchorEl={anchorElFace}
                  transition
                  disablePortal
                  placement={"bottom"}

                >
                  {() => (
                    <Grow
                      in={Boolean(anchorElFace)}
                      style={{ transformOrigin: "0 0 0" }}
                    >
                      <Paper className={classes.dropdown}>
                        <ClickAwayListener onClickAway={handleCloseAwayFace}>
                          <MenuList role="menu" className={classes.menuList}>
                            {lstFacebook.map((prop, key) => {
                              return (
                                <a key={key} href={prop.sURL} target="_blank" style={{ textDecoration: "none", color: '#757575' }}>
                                  <MenuItem
                                    key={key}
                                    className={classes.dropdownItem}
                                  >
                                    {prop.sLinkSetUpName}
                                  </MenuItem>
                                </a>
                              );
                            })}
                          </MenuList>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Popper>
              </>
            )}
            {lstYoutube.length == 0 ? (
              <div></div>
            ) : lstYoutube.length == 1 ? (
              <a href={lstYoutube[0].sURL} target="_blank">
                <IconButton className={classes.IconBtn}>
                  <FontAwesomeIcon icon={['fab', 'youtube']} style={{ color: '#ff0000' }} />
                </IconButton>
              </a>

            ) : (
              <>
                <IconButton
                  onClick={handleClickYoutube}
                  className={classes.IconBtn}
                >
                  <FontAwesomeIcon icon={['fab', 'youtube']} style={{ color: '#ff0000' }} />
                </IconButton>
                <Popper
                  open={Boolean(anchorElYoutube)}
                  anchorEl={anchorElYoutube}
                  transition
                  disablePortal
                  placement={"bottom"}

                >
                  {() => (
                    <Grow
                      in={Boolean(anchorElYoutube)}
                      style={{ transformOrigin: "0 0 0" }}
                    >
                      <Paper className={classes.dropdown}>
                        <ClickAwayListener onClickAway={handleCloseAwayYoutube}>
                          <MenuList role="menu" className={classes.menuList}>

                            {lstYoutube.map((prop, key) => {
                              return (
                                <a key={key} href={prop.sURL} target="_blank" style={{ textDecoration: "none", color: '#757575' }}>
                                  <MenuItem
                                    key={key}
                                    className={classes.dropdownItem}
                                  >
                                    {prop.sLinkSetUpName}
                                  </MenuItem>
                                </a>
                              );
                            })}
                          </MenuList>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Popper>
              </>
            )}
            {lstLine.length == 0 ? (
              <div></div>
            ) : lstLine.length == 1 ? (
              <a href={lstLine[0].sURL} target="_blank" style={{ textDecoration: "none", color: '#757575' }}>
                <IconButton className={classes.IconBtn}>
                  <FontAwesomeIcon icon={['fab', 'line']} style={{ color: '#00c300' }} />
                </IconButton>
              </a>
            ) : (
              <>
                <IconButton
                  onClick={handleClickLine}
                  className={classes.IconBtn}
                >
                  <FontAwesomeIcon icon={['fab', 'line']} style={{ color: '#00c300' }} />
                </IconButton>
                <Popper
                  open={Boolean(anchorElLine)}
                  anchorEl={anchorElLine}
                  transition
                  disablePortal
                  placement={"bottom"}
                >
                  {() => (
                    <Grow
                      in={Boolean(anchorElLine)}
                      style={{ transformOrigin: "0 0 0" }}
                    >
                      <Paper className={classes.dropdown}>
                        <ClickAwayListener onClickAway={handleCloseAwayLine}>
                          <MenuList role="menu" className={classes.menuList}>
                            {lstLine.map((prop, key) => {
                              return (
                                <a key={key} href={prop.sURL} target="_blank" style={{ textDecoration: "none", color: '#757575' }}>
                                  <MenuItem
                                    key={key}
                                    className={classes.dropdownItem}
                                  >
                                    {prop.sLinkSetUpName}
                                  </MenuItem>
                                </a>
                              );
                            })}
                          </MenuList>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Popper>
              </>
            )}
            {lstWord.length == 0 ? (
              <div></div>
            ) : lstWord.length == 1 ? (
              <a href={lstWord[0].sURL} target="_blank">
                <IconButton className={classes.IconBtn}>
                  <img src={workPlace} alt={"workplace"} width="22px" height="21px" style={{ borderRadius: '4px' }} />
                  {/* <FontAwesomeIcon icon={['fab', 'wordpress']} style={{color:'#21759b'}}/> */}
                </IconButton>
              </a>
            ) : (
              <>
                <IconButton
                  onClick={handleClickWordp}
                  className={classes.IconBtn}
                >
                  <img src={workPlace} alt={"workplace"} width="22px" height="21px" style={{ borderRadius: '4px' }} />
                  {/* <FontAwesomeIcon icon={['fab', 'wordpress']} style={{color:'#21759b'}}/> */}
                </IconButton>
                <Popper
                  open={Boolean(anchorElWordp)}
                  anchorEl={anchorElWordp}
                  transition
                  disablePortal
                  placement={"bottom"}

                >
                  {() => (
                    <Grow
                      in={Boolean(anchorElWordp)}
                      style={{ transformOrigin: "0 0 0" }}
                    >
                      <Paper className={classes.dropdown}>
                        <ClickAwayListener onClickAway={handleCloseAwayWordp}>
                          <MenuList role="menu" className={classes.menuList}>
                            {lstWord.map((prop, key) => {
                              return (
                                <a key={key} href={prop.sURL} target="_blank" style={{ textDecoration: "none", color: '#757575' }}>
                                  <MenuItem
                                    key={key}
                                    className={classes.dropdownItem}
                                  >
                                    {prop.sLinkSetUpName}
                                  </MenuItem>
                                </a>
                              );
                            })}
                          </MenuList>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Popper>
              </>
            )}
          </ListItem>
        </Hidden>
        {/* Search */}
        <ListItem className={classes.listItem}>
          <Divider orientation="vertical" style={{ height: '70px', marginTop: '8px' }} />
        </ListItem>
        <ListItem className={classes.listItem}>
          <SearchWeb />
        </ListItem>
        {/* UserInfo */}
        <ListItem className={classes.listItem}>
          <UserInfo />
        </ListItem>
        {/* Notification */}
        <ListItem className={classes.listItem} style={{ marginTop: "10px" }}>
          <Notification />
        </ListItem>
        {/* Menu */}
        <ListItem className={classes.listItem} style={{ marginTop: "10px" }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="end"
            onClick={() => setOpen(true)}
            className={clsx(open && classes.hide)}
            style={{ color: '#000000' }}
          >
            <MenuIcon />
          </IconButton>
        </ListItem>
      </List>
    </div>
  );
  const LeftL = (
    <div>
      <List className={classes.list}>
        <ListItem className={classes.listItem}>
          <Link to="/Homepage" style={{ textDecoration: "none" }}>
            <img src={PTTLogo} alt="logo" width="120" height="53.48" />
          </Link>
        </ListItem>
        <Hidden smDown>
          <ListItem className={classes.listItem}>
            <Link to="/Homepage" style={{ textDecoration: "none" }}>
              <Typography
                variant="h6"
                style={{
                  fontSize: "21px",
                  color: "#23247a",
                  marginTop: "14px",
                }}
              >
                GSP <b style={{ color: '#096ddd' }}>INNOVATION</b>
              </Typography>
            </Link>
          </ListItem>
        </Hidden>
      </List>
    </div>
  );

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open || IsOpenAppbar,
        })}
      >
        <Toolbar>
          <div className={classes.flex}>
            <Hidden mdUp>{brandComponent}</Hidden>
            <Hidden smDown>{LeftL}</Hidden>
          </div>
          <Hidden smDown>{RigthL}</Hidden>
          <Hidden mdUp>
            <Grid container spacing={3} justify="flex-end">
              <Grid item style={{ display: !matches && (IsOpenAppbar || open)  ? 'none' : 'block' }}>
                <IconButton
                  edge="end"
                  onClick={() => {
                    setIsOpenAppbar(!IsOpenAppbar);
                    setOpen(false);
                  }}
                  
                  // className={clsx((IsOpenAppbar || open) && classes.hide)}
                  style={{ color: '#000000'}}
                >
                  <SearchIcon />
                </IconButton>
              </Grid>
              {/* <Grid item className={clsx((IsOpenAppbar || open) && classes.hide)}> */}
              <Grid item style={{ display: !matches && (IsOpenAppbar || open)  ? 'none' : 'block' }}>
                <Notification />
              </Grid>
              <Grid item style={{ display: !matches && (IsOpenAppbar || open)  ? 'none' : 'block' }}>
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  edge="end"
                  onClick={() => {setOpen(!open);setIsOpenAppbar(false);}}
                  // className={clsx((IsOpenAppbar || open) && classes.hide)}
                  style={{ color: '#000000'}}
                >
                  <MenuIcon />
                </IconButton>
              </Grid>
            </Grid>
          </Hidden>
        </Toolbar>
      </AppBar>


      <main
        className={clsx(classes.contentA, {
          [classes.contentShift]: open || IsOpenAppbar,
        })}
      >
        <div className={classes.drawerHeader} />
        {props.children}
        <Footer />
      </main>
      <Drawer
        className={classes.drawer}
        variant="persistent"
        anchor="right"
        open={open}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.drawerHeaderMenu}>
          <IconButton onClick={() => setOpen(false)}>
            {theme.direction === 'rtl' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
        </div>
        <Divider />
        <List>
          {/* Component Menu list */}
          <SideBar depthStep={5} depth={0} items={lstMenu} />

          <ListItem dense button={true} onClick={() => handleLogOutClick("click")} style={{ height: '50px' }}>
            <ListItemIcon style={{ minWidth: '25px' }}>
              <ExitToAppIcon style={{ marginLeft: '-5px' }} />
            </ListItemIcon>
            <span style={{ color: '#757575' }}>Log out</span>
          </ListItem>
        </List>
      </Drawer>
      {/* Responsive Search/Profile */}
      <Drawer
        // className={classes.drawer}
        variant="persistent"
        anchor="right"
        open={IsOpenAppbar}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.drawerHeaderMenu}>
          <IconButton onClick={() => setIsOpenAppbar(false)}>
            {theme.direction === 'rtl' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
        </div>
        <Divider />
        <List>

          <ListItem>
            <Grid container spacing={3} justify="center">
              <Grid item>
                <UserInfo />
              </Grid>
            </Grid>
          </ListItem>
          <ListItem>
            <Grid container spacing={3} justify="center">
              <Grid item>
                <SearchWeb />
              </Grid>
            </Grid>
          </ListItem>
          <ListItem className={classes.listItem} >
            <Grid container spacing={3} justify="center">
              <Grid item>
                {lstFacebook.length == 0 ? (
                  <div></div>
                ) : lstFacebook.length == 1 ? (
                  <a href={lstFacebook[0].sURL} target="_blank">
                    <IconButton className={classes.IconBtn}>
                      <FontAwesomeIcon icon={['fab', 'facebook-square']} style={{ color: '#1773ea' }} />
                    </IconButton>
                  </a>
                ) : (
                  <>
                    <IconButton
                      onClick={handleClickFace}
                      className={classes.IconBtn}
                    >
                      <FontAwesomeIcon icon={['fab', 'facebook-square']} style={{ color: '#1773ea' }} />
                    </IconButton>
                    <Popper
                      open={Boolean(anchorElFace)}
                      anchorEl={anchorElFace}
                      transition
                      disablePortal
                      placement={"bottom"}

                    >
                      {() => (
                        <Grow
                          in={Boolean(anchorElFace)}
                          style={{ transformOrigin: "0 0 0" }}
                        >
                          <Paper className={classes.dropdown}>
                            <ClickAwayListener onClickAway={handleCloseAwayFace}>
                              <MenuList role="menu" className={classes.menuList}>
                                {lstFacebook.map((prop, key) => {
                                  return (
                                    <a key={key} href={prop.sURL} target="_blank" style={{ textDecoration: "none", color: '#757575' }}>
                                      <MenuItem
                                        key={key}
                                        className={classes.dropdownItem}
                                      >
                                        {prop.sLinkSetUpName}
                                      </MenuItem>
                                    </a>
                                  );
                                })}
                              </MenuList>
                            </ClickAwayListener>
                          </Paper>
                        </Grow>
                      )}
                    </Popper>
                  </>
                )}
                {lstYoutube.length == 0 ? (
                  <div></div>
                ) : lstYoutube.length == 1 ? (
                  <a href={lstYoutube[0].sURL} target="_blank">
                    <IconButton className={classes.IconBtn}>
                      <FontAwesomeIcon icon={['fab', 'youtube']} style={{ color: '#ff0000' }} />
                    </IconButton>
                  </a>

                ) : (
                  <>
                    <IconButton
                      onClick={handleClickYoutube}
                      className={classes.IconBtn}
                    >
                      <FontAwesomeIcon icon={['fab', 'youtube']} style={{ color: '#ff0000' }} />
                    </IconButton>
                    <Popper
                      open={Boolean(anchorElYoutube)}
                      anchorEl={anchorElYoutube}
                      transition
                      disablePortal
                      placement={"bottom"}

                    >
                      {() => (
                        <Grow
                          in={Boolean(anchorElYoutube)}
                          style={{ transformOrigin: "0 0 0" }}
                        >
                          <Paper className={classes.dropdown}>
                            <ClickAwayListener onClickAway={handleCloseAwayYoutube}>
                              <MenuList role="menu" className={classes.menuList}>

                                {lstYoutube.map((prop, key) => {
                                  return (
                                    <a key={key} href={prop.sURL} target="_blank" style={{ textDecoration: "none", color: '#757575' }}>
                                      <MenuItem
                                        key={key}
                                        className={classes.dropdownItem}
                                      >
                                        {prop.sLinkSetUpName}
                                      </MenuItem>
                                    </a>
                                  );
                                })}
                              </MenuList>
                            </ClickAwayListener>
                          </Paper>
                        </Grow>
                      )}
                    </Popper>
                  </>
                )}
                {lstLine.length == 0 ? (
                  <div></div>
                ) : lstLine.length == 1 ? (
                  <a href={lstLine[0].sURL} target="_blank" style={{ textDecoration: "none", color: '#757575' }}>
                    <IconButton className={classes.IconBtn}>
                      <FontAwesomeIcon icon={['fab', 'line']} style={{ color: '#00c300' }} />
                    </IconButton>
                  </a>
                ) : (
                  <>
                    <IconButton
                      onClick={handleClickLine}
                      className={classes.IconBtn}
                    >
                      <FontAwesomeIcon icon={['fab', 'line']} style={{ color: '#00c300' }} />
                    </IconButton>
                    <Popper
                      open={Boolean(anchorElLine)}
                      anchorEl={anchorElLine}
                      transition
                      disablePortal
                      placement={"bottom"}

                    >
                      {() => (
                        <Grow
                          in={Boolean(anchorElLine)}
                          style={{ transformOrigin: "0 0 0" }}
                        >
                          <Paper className={classes.dropdown}>
                            <ClickAwayListener onClickAway={handleCloseAwayLine}>
                              <MenuList role="menu" className={classes.menuList}>
                                {lstLine.map((prop, key) => {
                                  return (
                                    <a key={key} href={prop.sURL} target="_blank" style={{ textDecoration: "none", color: '#757575' }}>
                                      <MenuItem
                                        key={key}
                                        className={classes.dropdownItem}
                                      >
                                        {prop.sLinkSetUpName}
                                      </MenuItem>
                                    </a>
                                  );
                                })}
                              </MenuList>
                            </ClickAwayListener>
                          </Paper>
                        </Grow>
                      )}
                    </Popper>
                  </>
                )}
                {lstWord.length == 0 ? (
                  <div></div>
                ) : lstWord.length == 1 ? (
                  <a href={lstWord[0].sURL} target="_blank">
                    <IconButton className={classes.IconBtn}>
                      <img src={workPlace} alt={"workplace"} width="22px" height="21px" style={{ borderRadius: '4px' }} />
                      {/* <FontAwesomeIcon icon={['fab', 'wordpress']} style={{color:'#21759b'}}/> */}
                    </IconButton>
                  </a>
                ) : (
                  <>
                    <IconButton
                      onClick={handleClickWordp}
                      className={classes.IconBtn}
                    >
                      <img src={workPlace} alt={"workplace"} width="22px" height="21px" style={{ borderRadius: '4px' }} />
                      {/* <FontAwesomeIcon icon={['fab', 'wordpress']} style={{color:'#21759b'}}/> */}
                    </IconButton>
                    <Popper
                      open={Boolean(anchorElWordp)}
                      anchorEl={anchorElWordp}
                      transition
                      disablePortal
                      placement={"bottom"}
                    >
                      {() => (
                        <Grow
                          in={Boolean(anchorElWordp)}
                          style={{ transformOrigin: "0 0 0" }}
                        >
                          <Paper className={classes.dropdown}>
                            <ClickAwayListener onClickAway={handleCloseAwayWordp}>
                              <MenuList role="menu" className={classes.menuList}>
                                {lstWord.map((prop, key) => {
                                  return (
                                    <a key={key} href={prop.sURL} target="_blank" style={{ textDecoration: "none", color: '#757575' }}>
                                      <MenuItem
                                        key={key}
                                        className={classes.dropdownItem}
                                      >
                                        {prop.sLinkSetUpName}
                                      </MenuItem>
                                    </a>
                                  );
                                })}
                              </MenuList>
                            </ClickAwayListener>
                          </Paper>
                        </Grow>
                      )}
                    </Popper>
                  </>
                )}
              </Grid>
            </Grid>
          </ListItem>
        </List>
      </Drawer>

    </div>
  );
}

export default Layout;
